import { Component } from '@angular/core';

@Component({
  selector: 'app-navbar-button-notifactions',
  templateUrl: './navbar-button-notifactions.component.html',
  styleUrls: ['./navbar-button-notifactions.component.scss'],
})
export class NavbarButtonNotifactionsComponent {
}
